// extracted by css-extract-rspack-plugin
export default {"root":"src-modules-desktop-modules-widgets-components-ViewportMount-ViewportMount-module__root-Qu88uU"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-modules-desktop-modules-widgets-components-ViewportMount-ViewportMount-module__root-Qu88uU\"}";
        // 1793872694923
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  